import { useState } from 'react';
import { useCreate, useNotify } from 'react-admin';
import SendIcon from '@mui/icons-material/Send';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function SendInsuranceQuoteModal({
  onClose = () => {},
  isOpen = false,
  payload = {},
}) {
  const notify = useNotify();
  const [create, { isLoading: isCreateLoading }] = useCreate();

  const [email, setEmail] = useState('');

  function handleSendEmailClick() {
    create(
      `policies/send-quote-link`,
      { data: { ...payload, email: email } },
      {
        onSuccess: () => {
          onClose();
          setEmail('');
          notify(`Email sent.`, 'info');
        },
        onError: error => {
          notify(
            `There was an error when sending the email: ${error.message}`,
            'warning'
          );
        },
      }
    );
  }

  return (
    <Dialog open={isOpen} onClose={onClose} aria-label='Non Conversion Quote'>
      <div
        style={{
          width: '500px',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '24px',
          alignItems: 'center',
        }}
      >
        <Typography
          style={{
            fontSize: '20px',
            lineHeight: '24px',
            fontWeight: '500',
            color: 'black',
          }}
        >
          SEND QUOTE TO
        </Typography>
      </div>
      <DialogContent style={{ display: 'inline-grid' }}>
        <div style={{ margin: '16px 0px' }}>
          <TextField
            label='Email Address'
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button
          disabled={isCreateLoading}
          onClick={() => onClose()}
          style={{ color: '#D4424E' }}
        >
          CANCEL
        </Button>
        <IconButton
          style={{ padding: '0px 8px', color: '#3F51B5' }}
          onClick={() => handleSendEmailClick()}
          size='large'
          disabled={isCreateLoading || !email}
        >
          <SendIcon style={{ paddingRight: '3px' }} />
          <Typography style={{ fontSize: '14px' }}>SEND</Typography>
        </IconButton>
      </DialogActions>
    </Dialog>
  );
}

SendInsuranceQuoteModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  payload: PropTypes.object,
};

export default SendInsuranceQuoteModal;
